import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'

export const TextHeaderSl = () => {
    const isDesktop = useMediaQuery('(min-width: 540px)')

    return (
        <HighlightedText
            text="ZAVRTI KOLO IN OSVOJI BREZPLAČNE VRTLJAJ"
            highlights={[{ word: 'BREZPLAČNE' }, { word: 'VRTLJAJ' }]}
            breakAfterWords={isDesktop ? ['OSVOJI'] : ['OSVOJI', 'BREZPLAČNE']}
            className={common.text_header}
        />
    )
}
